{
  "name": "atlas",
  "version": "2.14.3-beta-890-g1e2bfa6.0.56",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-dev": "ng serve --c=local-dev",
    "start-staging": "ng serve --c=local-staging",
    "start-prod": "ng serve --c=local-production",
    "build": "ng build",
    "build-prod": "node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --c=production",
    "build-staging": "node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --c=staging",
    "build-dev": "node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --c=dev",
    "test": "ng test",
    "e2e": "ng e2e",
    "br": "br",
    "pretty-quick": "npx pretty-quick",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular-slider/ngx-slider": "^22.0.0",
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.0",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/material": "^22.1.0",
    "@angular/material-moment-adapter": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/platform-browser-dynamic": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@angular/service-worker": "^22.1.0",
    "@brafton/angular-catalog-library": "0.1.1-beta-80-gf8cf1db.0.35",
    "@brafton/angular-framework-library": "1.0.1-beta-381-g042da89.0.238",
    "@brafton/angular-styles-library": "2.2.2-beta-386-g2ae93cf.0.78",
    "@brafton/assets-api": "4.1.1-beta-31-g4f124e5.0.4",
    "@brafton/atlas-api-client": "2.5.4-rc.0.1",
    "@brafton/catalog-api-client": "0.8.1",
    "@brafton/common-framework-library": "2.0.11-beta-225-g4f9de2a.0.2",
    "@brafton/core-api-client": "4.1.5-beta-71-g5f97266.0.2",
    "@brafton/deliverables-client": "6.6.2-beta-432-gf055c91.0.4",
    "@brafton/logentries-client": "0.0.0-beta-7-gb6dc27d.0.6",
    "@brafton/marketing-api-client-angular": "0.0.0-beta-173-g14a5615.0.73",
    "@brafton/skynet-angular-security-service": "8.3.4-rc.0.3",
    "@brafton/text-api-client": "2.5.5-beta-353-gd0ee9eb.0.6",
    "@ckeditor/ckeditor5-angular": "^7.0.1",
    "@ckeditor/ckeditor5-markdown-gfm": "^40.1.0",
    "@ckeditor/ckeditor5-watchdog": "^40.2.0",
    "@types/ckeditor": "^4.9.10",
    "@types/lodash": "^4.14.170",
    "angular-split": "^18.0.0",
    "auth0-js": "^9.19.1",
    "auth0-lock": "^11.34.0",
    "buffer": "^6.0.3",
    "chart.js": "^4.4.0",
    "file-saver": "^2.0.5",
    "file-type": "^16.5.4",
    "html-to-docx": "^1.8.0",
    "html-to-docx-lite": "^2.0.1",
    "html-to-pdfmake": "^2.5.23",
    "i": "^0.3.7",
    "json-formatter-js": "^2.5.17",
    "libphonenumber-js": "^1.9.20",
    "marked": "^18.0.7",
    "moment": "^2.29.1",
    "ng2-charts": "^8.0.0",
    "ngx-moment": "^6.0.2",
    "ngx-quill": "^31.0.1",
    "npm": "^10.8.1",
    "object-hash": "^3.0.0",
    "pdfmake": "^0.2.18",
    "process": "^0.11.10",
    "quill": "^2.0.3",
    "quill-delta": "^5.1.0",
    "rehype-raw": "^7.0.0",
    "rehype-stringify": "^10.0.0",
    "remark-directive": "^4.0.0",
    "remark-gfm": "^4.0.0",
    "remark-html": "^16.0.1",
    "remark-parse": "^11.0.0",
    "remark-rehype": "^11.1.0",
    "rxjs": "^7.8.0",
    "showdown": "^2.1.0",
    "tslib": "^2.3.0",
    "unified": "^11.0.4",
    "unist-util-visit": "^5.0.0",
    "url": "^0.11.4",
    "util": "^0.12.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular/build": "^22.1.6",
    "@angular/cli": "~22.1.2",
    "@angular/compiler-cli": "^22.1.0",
    "@eslint/js": "^9.39.0",
    "@types/auth0-js": "9.14.4",
    "@types/auth0-lock": "11.27.4",
    "@types/jasmine": "~4.0.0",
    "@types/node": "^22.12.0",
    "@types/object-hash": "^2.2.1",
    "@types/showdown": "^2.0.6",
    "angular-eslint": "^22.1.0",
    "babel-loader": "^8.2.2",
    "css-loader": "^6.8.1",
    "eslint": "^9.39.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.3.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "prettier": "^3.4.2",
    "pretty-quick": "^4.0.0",
    "resize-observer-polyfill": "^1.5.1",
    "style-loader": "^3.3.3",
    "ts-node": "~10.2.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.46.0",
    "webpack": "5.105.2"
  }
}
